module.exports = __webpack_public_path__ + "static/media/emojiLunette.992ca377.png";